import { render } from "./Header_bak_20260401.vue?vue&type=template&id=a3d97530"
import script from "./Header_bak_20260401.vue?vue&type=script&lang=js"
export * from "./Header_bak_20260401.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__